import React from 'react';
import { Box, Typography } from '@mui/material'
import {  ProgressBar, ProgressIndicator } from '../../../core/components/styled/StyledComponents';
import { ENROLLMENT_FORM_STEPS } from '../../../core/constant/constant';

interface MobileHeaderProps {
  activeStep: number;
  getProgressValue: () => number;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ activeStep, getProgressValue }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h5' color='text.primary' sx={{ mb: 1 }}>
        {ENROLLMENT_FORM_STEPS[activeStep]?.title}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <ProgressBar sx={{ backgroundColor: 'rgba(67, 97, 238, 0.3)' }}>
          <ProgressIndicator
            value={getProgressValue()}
            sx={{ backgroundColor: '#4361ee' }}
          />
        </ProgressBar>
      </Box>
    </Box>
  );
};

export default MobileHeader;